module.exports = __webpack_public_path__ + "img/x6.0ee4dce7.jpg";